import { createSelector } from '@reduxjs/toolkit';

import { createMessages } from '_helpers/messages';

export const selectParamsByType = (type) => (state) => state.messages[type].params;
export const selectDataByType = (type) => (state) => state.messages[type].data;
export const selectErrorByType = (type) => (state) => state.messages[type].error;
export const selectFetchCounterByType = (type) => (state) => state.messages[type].fetchCounter;
export const selectLoadingByType = (type) => (state) => state.messages[type].loading;

export const selectMessagesByType = (type) =>
  createSelector([selectDataByType(type)], (data) => {
    const messages = createMessages(data?.elements);
    return { ...data, elements: messages };
  });
